import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "mobilemenu",
  id: "search-page"
}

import { computed } from "vue";
import { useSearchPageStore } from "@/store/store/searchPageStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchPageMobileMenu',
  emits: ["changeLayout"],
  setup(__props, { emit: __emit }) {

const searchPageStore = useSearchPageStore();

const searchPageState = computed(() => searchPageStore.searchPageState);

const emit = __emit;

function changeLayout(layout: string) {
  searchPageStore.searchPageState.layout = layout;
  emit("changeLayout", layout);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "xsearchfilters icon-menu",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (
        _unref(searchPageStore).searchPageState.filterDisplay =
          !_unref(searchPageStore).searchPageState.filterDisplay
      ))
    }, " Filters "),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (changeLayout('boxes'))),
      class: _normalizeClass(["icon-th button-style", { xselected: searchPageState.value.layout == 'boxes' }])
    }, null, 2),
    _createElementVNode("button", {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (changeLayout('table'))),
      class: _normalizeClass(["icon-list button-style", { xselected: searchPageState.value.layout == 'table' }])
    }, null, 2),
    (searchPageState.value.advancedSearchEnabled)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (searchPageState.value.showAdvancedSearchModal = true))
        }, " Advanced Search "))
      : _createCommentVNode("", true)
  ]))
}
}

})